import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH_SUFFIX = "/recipes/update";
/** /customer/subscription/recipes/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH = `${SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_UPDATE_FRESH_RECIPES_PATH_SUFFIX}`;
